import { Configuration as MsalConfiguration, PublicClientApplication } from '@azure/msal-browser';
import { initializeMsal } from '@synqo/cloud-client-shared';
import { useEffect, useState } from 'react';

export function useMsal(configuration: MsalConfiguration | undefined) {
    const [msalInstance, setMsalInstance] = useState<PublicClientApplication>();

    useEffect(() => {
        if (configuration === undefined) {
            return;
        }

        void initializeMsal(configuration).then(setMsalInstance);
    }, [configuration]);

    return msalInstance;
}
